module.exports = __webpack_public_path__ + "img/icon-good.5562913f.svg";